module.exports = __webpack_public_path__ + "static/media/stockhausen_augen_26.e0127f8a.jpg";